import cookie from 'utils/cookie';

import {
  HIDE_10DLC_BANNER,
  HIDE_CREATE_INBOX,
  HIDE_MOBILE_NAV,
  SHOW_10DLC_BANNER,
  SHOW_CREATE_INBOX,
  SHOW_MOBILE_NAV,
  TOGGLE_CREATE_MESSAGE,
  TOGGLE_DIALER,
  TOGGLE_NEW_WORKFLOW_MODAL,
} from './types';

export function getInitialNav() {
  try {
    const nav = cookie.get('nav_expanded');
    console.log({ nav });
    if (nav) {
      return nav === '1';
    }
    return false;
  } catch {}
}

export const showMobileNav = () => {
  cookie.set('nav_expanded', '1', { path: '/' });
  return {
    type: SHOW_MOBILE_NAV,
  };
};
export const hideMobileNav = () => {
  cookie.set('nav_expanded', '0', { path: '/' });
  return {
    type: HIDE_MOBILE_NAV,
  };
};
export const showCreateInboxModal = () => ({ type: SHOW_CREATE_INBOX });

export const toggleDialer = (show, params) => ({
  type: TOGGLE_DIALER,
  payload: { show, params },
});

export const toggleCreateMessageModal = (show, contacts) => ({
  type: TOGGLE_CREATE_MESSAGE,
  payload: show ? { contacts } : false,
});

export const toggleNewWorkflowModal = (show) => ({
  type: TOGGLE_NEW_WORKFLOW_MODAL,
  payload: show,
});

export const show10DLCBanner = (payload) => ({
  type: SHOW_10DLC_BANNER,
  payload,
});

export const hide10DLCBanner = (payload) => ({
  type: HIDE_10DLC_BANNER,
  payload,
});
